import { OnoffswitchComponent } from './onoffswitch/onoffswitch.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PanelSwitchComponent, PanelComponent } from '@app/modules/shared/panel-switch/panel-switch.component';
import { GoogleplaceDirective } from '@app/directives/googleplace';
import { InputSwitchComponent } from './input-switch/input-switch.component';
import { InputCheckComponent } from './input-check/input-check.component';
import { Panel2Component, PanelSwitch2Component } from './panel-switch2/panel-switch2.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CollapseModule,
    BsDropdownModule.forRoot()
  ],
  declarations: [
    PanelSwitchComponent,
    PanelSwitch2Component,
    Panel2Component,
    PanelComponent,
    OnoffswitchComponent,
    GoogleplaceDirective,
    InputSwitchComponent,
    InputCheckComponent
  ],
  exports: [
    PanelSwitchComponent,
    PanelSwitch2Component,
    Panel2Component,
    PanelComponent,
    OnoffswitchComponent,
    GoogleplaceDirective,
    InputSwitchComponent,
    InputCheckComponent
  ]
})
export class SharedModule { }
